import { render, staticRenderFns } from "./comCube.vue?vue&type=template&id=e1bf9872&scoped=true"
import script from "./comCube.vue?vue&type=script&lang=js"
export * from "./comCube.vue?vue&type=script&lang=js"
import style0 from "./comCube.vue?vue&type=style&index=0&id=e1bf9872&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1bf9872",
  null
  
)

export default component.exports